import { useMutation } from '@tanstack/react-query';
import axios from 'axios';
import queryClient from 'queries';

export type AiDispatchRequest = {
  user_instruction: string;
  departure_date: string;
};

export function useRequestAiDispatch() {
  return useMutation({
    mutationKey: ['ai/dispatch'],
    mutationFn: (body: AiDispatchRequest) => axios.post('/ai', body, { timeout: 5 * 60 * 1000 }).then((response) => response.data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['trip/fetch_entity_list'] });
      queryClient.invalidateQueries({ queryKey: ['orders/fetch_entity_list'] });
      queryClient.invalidateQueries({ queryKey: ['trip_manifest/fetch_entity'] });
    },
  });
}
